module.exports = __webpack_public_path__ + "static/media/own_blend_square.64fd55d5.jpg";